'use client';

import { useEffect } from 'react';

import { useIsLoggedIn } from '@air/utils-auth';

import { useIsUserVerified } from '~/hooks/useIsUserVerified';

export type UseVerifyUserScreenParams = {
  onUnauthenticated: () => void;
  onVerified: () => void;
};

export const useVerifyUserScreen = ({ onUnauthenticated, onVerified }: UseVerifyUserScreenParams) => {
  const { isLoggedIn, isLoggedInFetched } = useIsLoggedIn();
  const { isFetched, isRefreshing, refreshUserVerification, userEmail, userEmailIsVerified } = useIsUserVerified();

  useEffect(() => {
    if (isLoggedInFetched && !isLoggedIn) {
      onUnauthenticated();
    }
  }, [isLoggedIn, isLoggedInFetched, onUnauthenticated]);

  useEffect(() => {
    if (!isLoggedInFetched || !isLoggedIn || !isFetched) {
      return;
    }

    if (userEmailIsVerified === true) {
      onVerified();
    }
  }, [isFetched, isLoggedIn, isLoggedInFetched, onVerified, userEmailIsVerified]);

  const canShowPage = isLoggedInFetched && isLoggedIn && isFetched && userEmailIsVerified === false && !!userEmail;

  return {
    canShowPage,
    email: userEmail,
    isRefreshing,
    refreshUserVerification,
  };
};
